<template>
    <div style="background-image: url('/WholisticLife.jpg')">
        <div class="uk-padding-large" style="background-color: rgba(3, 56, 96, 0.6)">
            <div class="uk-container">
                <h2 class="uk-text-bold uk-light uk-text-center">Explore our Programmes</h2>
                <p class="uk-text-center uk-light uk-text-small">Endless possibilities start with this first step</p>
                <div class="uk-text-center">
                    <router-link class="uk-button uk-button-default uk-button-large uk-text-capitalize  " style="font-size: large; color: rgba(251, 251, 251, 0.8) !important;" to="/UndergradPrograms">
                                 See Programmes
                        <span uk-icon="chevron-right"></span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "exploreUndergradPrograms"
    }
</script>

<style scoped>
    h2{
        color: rgba(251, 215, 3, 1) !important;
    }
    @media screen and (max-width:600px){


        h2{
            font-size: 1.4em !important;
        }
        p{
            font-size: 0.8em !important;
        }

    }
</style>
